import { LoadBankListData } from "services/interface";
import styled from "@emotion/styled";
import { Button, DatePicker, Pagination, Row, Space } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import BankCard from "../BankItemsCard";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
dayjs.locale('th');
interface BankOnStatusProps {
  data: LoadBankListData | undefined;
  refetch: () => void;
  refetchTo: () => void;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  itemsPerPage: number;
  handleDateChange: (dates: any, dateStrings: [string, string]) => void;
  handleSearch: () => void;
  startDate: any;
  endDate: any;
  activeBankCount: number;
  isLunganek: boolean;
}

const BankOnStatus: FC<BankOnStatusProps> = ({
  data,
  refetch,
  refetchTo,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  handleDateChange,
  handleSearch,
  startDate,
  endDate,
  activeBankCount,
  isLunganek,
}) => {

  const dateFormat = 'YYYY/MM/DD';

  const handleAfterDelete = () => {
    if (currentPage > 1 && data && data.bank_list.length <= 1) {
      setCurrentPage(currentPage - 1);
    } else {
      refetch();
    }
  };

  return (
    <WrapperAll>
      <Row >
        <HeadWrapper>
        <ButtonWrapper>
          <Space.Compact>
            <RangePicker
              defaultValue={[startDate, endDate]}
              format={dateFormat}              
              placeholder={["วันที่เริ่มต้น","วันที่สิ้นสุด"]}
              onChange={handleDateChange}
            />
            <Button type="default" onClick={handleSearch}>ค้นหา</Button>
          </Space.Compact>
        </ButtonWrapper>
        <RightIconWrapper>
          <PaginationWrapper
            current={currentPage}
            size={'small'}
            responsive={true}
            onChange={(page) => setCurrentPage(page)}
            total={Number(data?.total_record) ?? 0}
            pageSize={itemsPerPage}
          />
        </RightIconWrapper>
        </HeadWrapper>
      </Row>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >

      { data && data?.bank_list.map((item) => {
        return (
          <BankCard
            key={item.id}
            data={item}
            refetch={refetch}
            refetchTo={refetchTo}
            handleAfterDelete={handleAfterDelete}
            activeBankCount={activeBankCount}
            isLunganek={isLunganek}
          />
        );
      })}
      </Row>
    </WrapperAll>
  );
};

export default BankOnStatus;
const WrapperAll = styled.div`
  background-color: #efefef;
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
`;

const PaginationWrapper = styled(Pagination)`
  white-space: nowrap;
`;
const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
 
const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;